import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { Achievement, AchievementsContainerState } from './achievements';

const initialState: AchievementsContainerState = {
  listAchievements: [],
  page: 0,
  pageSize: 20,
  total: 0,
  isFetching: false,
  search: '',
  showAchievementDetails: false,
};

export const slice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListAchievement: (state, action: PayloadAction<Achievement[]>) => {
      state.listAchievements = action.payload;
    },
    addAchievements: (state, action: PayloadAction<Achievement[]>) => {
      state.listAchievements = state.listAchievements.concat(action.payload);
      state.total += action.payload.length;
    },
    removeAchievement: (state, action: PayloadAction<string>) => {
      state.listAchievements = state.listAchievements.filter(
        (s) => s.id !== action.payload,
      );
      state.total = state.total - 1;
    },
    updateAchievementById: (state, action: PayloadAction<Achievement>) => {
      const index = state.listAchievements.findIndex(
        (s) => s.id === action.payload.id,
      );
      if (index !== -1) {
        const sp = state.listAchievements[index];
        Object.assign(sp, action.payload);
        state.listAchievements[index] = sp;
      }
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setActiveAchievement: (
      state,
      action: PayloadAction<Achievement | undefined>,
    ) => {
      state.activeAchievement = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    setShowAchievementDetails: (state, action: PayloadAction<boolean>) => {
      state.showAchievementDetails = action.payload;
    },
  },
});

export const {
  setListAchievement,
  addAchievements,
  removeAchievement,
  updateAchievementById,
  setPage,
  setActiveAchievement,
  setSearch,
  setTotal,
  setIsFetching,
  setShowAchievementDetails,
} = slice.actions;

export default slice.reducer;
